import { ReactNode } from 'react';

import {
  PersonMachineContext,
  usePersonData,
  getPersonMachineSnapshot,
} from '~domains/profile/entities/person';

import { AddressSuggestionApiProvider } from '~platform/entities/address-suggestion';

import { ErrorScreen } from '~shared/ui/error-screen';
import { Loader } from '~shared/ui/loader';

import isEmpty from '@tinkoff/utils/is/empty';

import { PersonFlowScreens } from './person-flow-screens';

type PersonFormProps = {
  navigation?: ReactNode;
};

export const PersonForm = ({ navigation }: PersonFormProps) => {
  const personDataQuery = usePersonData();

  if (personDataQuery.data) {
    const snapshot = isEmpty(personDataQuery.data)
      ? undefined
      : getPersonMachineSnapshot(personDataQuery.data);

    return (
      <AddressSuggestionApiProvider>
        <PersonMachineContext.Provider options={{ snapshot }}>
          {navigation}
          <PersonFlowScreens />
        </PersonMachineContext.Provider>
      </AddressSuggestionApiProvider>
    );
  }

  if (personDataQuery.isLoading) {
    return <Loader />;
  }

  if (personDataQuery.isError) {
    return <ErrorScreen message="Failed to load profile data." />;
  }

  return null;
};
